import { permissionGroup as apiPermissionGroup } from './api';

export { SendStableToInvestorModal } from './modal';

export const permissionGroup = apiPermissionGroup.createSuperGroup({
  marker: 'layout:send-stable-to-investor-modal',
});
